/*
 * Footer link columns.
 *
 * The markup ships with every column `open`, because a closed <details> hides
 * its children at the browser level and desktop needs them permanently visible.
 * Mobile wants them collapsed, so that is done here — which means without
 * JavaScript the mobile footer is simply long rather than broken.
 *
 * Wrapped in an IIFE because a second instance of this section on one
 * template loads this file with its own <script src>, so the browser
 * executes it twice; without the wrapper the second execution throws on the
 * repeated top-level `const`/`class` declarations before the
 * customElements.get() guard below ever runs.
 */
(function () {
const CD_FOOTER_MOBILE = '(max-width: 989px)';

class CdFooter extends HTMLElement {
  connectedCallback() {
    this.deferBackground();

    this.columns = Array.from(this.querySelectorAll('.cd-footer__col'));
    if (!this.columns.length) return;

    this.query = window.matchMedia(CD_FOOTER_MOBILE);
    this.sync = () => this.apply(this.query.matches);
    this.query.addEventListener('change', this.sync);
    this.sync();
  }

  disconnectedCallback() {
    this.query?.removeEventListener('change', this.sync);
    this.backgroundObserver?.disconnect();
  }

  // The photograph sits below the fold on every page, so it waits until the
  // footer is within a screen of view rather than loading with the hero.
  deferBackground() {
    const show = () => this.setAttribute('data-bg-ready', '');
    if (typeof IntersectionObserver === 'undefined') {
      show();
      return;
    }

    this.backgroundObserver?.disconnect();
    this.backgroundObserver = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.backgroundObserver.disconnect();
        show();
      },
      { rootMargin: '0px 0px 800px 0px' }
    );
    this.backgroundObserver.observe(this);
  }

  apply(isMobile) {
    this.columns.forEach((column) => {
      // Don't fight a shopper who has already opened a column on mobile.
      if (isMobile && !column.dataset.cdTouched) {
        column.open = false;
      } else if (!isMobile) {
        column.open = true;
      }
    });

    if (isMobile && !this.bound) {
      this.bound = true;
      this.columns.forEach((column) => {
        column.addEventListener('toggle', () => {
          column.dataset.cdTouched = 'true';
        });
      });
    }
  }
}

if (!customElements.get('cd-footer')) {
  customElements.define('cd-footer', CdFooter);
}
})();
